var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXMarkRedCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E80041"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7987 21.2171C42.1301 20.5485 41.0501 20.5485 40.3816 21.2171L31.9987 29.5828L23.6158 21.2C22.9473 20.5314 21.8673 20.5314 21.1987 21.2C20.5301 21.8685 20.5301 22.9485 21.1987 23.6171L29.5816 32L21.1987 40.3828C20.5301 41.0514 20.5301 42.1314 21.1987 42.8C21.8673 43.4685 22.9473 43.4685 23.6158 42.8L31.9987 34.4171L40.3816 42.8C41.0501 43.4685 42.1301 43.4685 42.7987 42.8C43.4673 42.1314 43.4673 41.0514 42.7987 40.3828L34.4158 32L42.7987 23.6171C43.4501 22.9657 43.4501 21.8685 42.7987 21.2171Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMarkRedCircle);
export default __webpack_public_path__ + "static/media/x-mark-red-circle.f32a99b8f06943a6d97db56f81d3e708.svg";
export { ForwardRef as ReactComponent };